import * as requestAccess from '../reducers/request-access/request-access.reducer';
import { createSelector } from '@ngrx/store';

export const getRequestAccessCaptcha = createSelector(
  requestAccess.getRequestAccessState,
  requestAccess.getRequestAccessCaptcha
);

export const getRequestAccessLoading = createSelector(
  requestAccess.getRequestAccessState,
  requestAccess.getRequestAccessLoading
);

export const getRequestAccessSuccess = createSelector(
  requestAccess.getRequestAccessState,
  requestAccess.getRequestAccessSuccess
);

export const getRequestAccessError = createSelector(
  requestAccess.getRequestAccessState,
  requestAccess.getRequestAccessError
);

